const ethers = require('ethers');

const _ = require('lodash');

const constants = require('./constants.js');
const BuilderRegistryAbi = require('./abis/BuilderRegistry.json');
const PayoutPoolAbi = require('./abis/PayoutPool.json');
const ReporterRegistryAbi = require('./abis/ReporterRegistry.json');
const ProposerRegistryAbi = require('./abis/ProposerRegistry.json')

const getContracts = async (signer) => {
    const networkId = await getNetworkId(signer);
    const networkName = constants.chainIdToNetworkmap[networkId];

    const {
        PROPOSER_REGISTRY,
        BUILDER_REGISTRY,
        PAYOUT_POOL,
        REPORTER_REGISTRY
    } = constants.CONTRACT_ADDRESSES[networkName];

    return {
        builderRegistry: new ethers.Contract(BUILDER_REGISTRY, BuilderRegistryAbi, signer),
        proposerRegistry: new ethers.Contract(PROPOSER_REGISTRY, ProposerRegistryAbi, signer),
        payoutPool: new ethers.Contract(PAYOUT_POOL, PayoutPoolAbi, signer),
        reporterRegistry: new ethers.Contract(REPORTER_REGISTRY, ReporterRegistryAbi, signer),
    }
};

const add0x = (data) => {
    if (!_.isString(data)) {
        return data;
    }

    return data.startsWith('0x') ? data : '0x' + data;
}

const remove0x = (data) => {
    if (!_.isString(data)) {
        return data;
    }

    return data.startsWith('0x') ? data.slice(2) : data
}

const getNetworkId = async (signerOrProvider) => {
    if (!signerOrProvider) {
        throw Error('No signer instance provided');
    }

    if(ethers.Signer.isSigner(signerOrProvider)) {
        return signerOrProvider.getChainId();
    }

    const network = await signerOrProvider.getNetwork();

    if(!network) {
        throw "Invalid signer or provider instance";
    }

    return network.chainId;
};

module.exports = {
    getContracts,
    add0x,
    remove0x,
    getNetworkId,
}